import { Map, OrderedSet } from 'immutable';
import type { Action } from '@reduxjs/toolkit';

import type { ReduxAction } from 'app/redux/types';

import { API, getAsyncThunk } from 'app/api';
import { StakeType } from 'app/lib/staking/constants';

import type { RecordOfEntryLimitsType, RecordOfPaymentOptionsEntry, RecordOfRankEntryType } from '../records';
import type { ExpressMatchPrices } from '../types/stakeTypes/express';

// ---

export const checkAvailability = getAsyncThunk(
  'BET_SLIP:CHECK_AVAILABILITY',
  API.betSlip.checkAvailability,
);

export type CheckAvailabilitySuccessPayload = {
  singles: {
    limits: Map<number, RecordOfEntryLimitsType>;
    paymentOptions: Map<number, RecordOfPaymentOptionsEntry>;
  };
  express: {
    limits: RecordOfEntryLimitsType;
    paymentOptions: RecordOfPaymentOptionsEntry;
    matchPrices: ExpressMatchPrices;
  };
  systems: {
    systemRankOf: number | null;
    rankEntries: Map<number, RecordOfRankEntryType>;
  };
  availableStakeTypes: OrderedSet<StakeType>;
};

// ---

export const REFRESH_AVAILABILITY = 'BET_SLIP:REFRESH_AVAILABILITY';

export type RefreshAvailability = ReduxAction<
  typeof REFRESH_AVAILABILITY,
  CheckAvailabilitySuccessPayload
>;

export const refreshAvailability = (
  payload: CheckAvailabilitySuccessPayload,
): RefreshAvailability => ({
  type: REFRESH_AVAILABILITY,
  payload,
});

// ---

export const CLEAR_BETS_INFO_ERROR = 'BET_SLIP:CLEAR_BETS_INFO_ERROR';

export type ClearBetsInfoError = ReduxAction<
  typeof CLEAR_BETS_INFO_ERROR,
  { betIds: number[] }
>;

export const clearBetsInfoErrorByBetIds = (betIds: number[]): ClearBetsInfoError => ({
  type: CLEAR_BETS_INFO_ERROR,
  payload: { betIds },
});

export const CLEANUP = 'BET_SLIP:CLEANUP';

export type Cleanup = Action<typeof CLEANUP>;

export const cleanup = (): Cleanup => ({ type: CLEANUP });
